import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '../../../../types';

export const useHeaderUserBoxStyles = makeStyles((theme: Theme) => {
    const { globals } = theme;

    const isDark = theme.palette.mode === 'dark';
    return {
        avatar: {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
            fontSize: '0.85rem',
            fontWeight: 600,
            width: 36,
            height: 36
        },
        // The avatar on the header bar: glass, like the bar's other controls.
        // The one in the user menu keeps the solid colour — glass would vanish
        // on the menu's white.
        avatarOnBar: {
            backgroundColor: 'rgba(255,255,255,0.15)',
            border: '1px solid rgba(255,255,255,0.25)'
        },
        userboxButton: {
            ...globals.textCapitalize,
            ...globals.getPadding('12px', 'l'),
            ...globals.getPadding('12px', 'r'),
            ...globals.textLeft,
            ...globals.dFlex,
            ...globals.alignItemsCenter
        },
        userboxButtonText: {
            ...globals.getPadding('18px', 'l'),
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'block'
            }
        },
        userboxButtonHeader: {
            ...globals.fontWeightBold,
            ...globals.getPadding('12px', 't'),
            ...globals.textNowrap,
            ...globals.lineHeight1
        },
        userboxButtonSubheader: {
            color: theme.palette.common.white50,
            ...globals.textNowrap
        },
        userboxButtonIconWrapper: {
            ...globals.getPadding('6px', 'l'),
            ...globals.getPadding('6px', 'r'),
            [theme.breakpoints.up('xl')]: {
                ...globals.getPadding('18px', 'l')
            }
        },
        userboxButtonIcon: {
            ...globals.opacity5
        },
        menu: {},
        menuRoot: {
            ...globals.getPadding('0px'),
            ...globals.overflowHidden
        },
        menuList: {
            ...globals.textLeft,
            ...globals.bgTransparent,
            ...globals.flexColumn,
            alignItems: 'stretch',
            ...globals.getPadding('0px', 't')
        },
        menuHeaderWrapper: {
            ...globals.getPadding('18px', 'l')
        },
        menuHeader: {
            ...globals.fontWeightBold,
            ...globals.textCenter,
            ...globals.getPadding('12px', 't'),
            ...globals.lineHeight1
        },
        menuSubheader: {
            color: theme.palette.common.black50,
            ...globals.textCenter
        },
        roleBadge: {
            display: 'inline-block',
            padding: '1px 8px',
            borderRadius: 999,
            backgroundColor: isDark ? 'rgba(123,79,224,0.22)' : '#ede4ff',
            color: isDark ? '#c3aef7' : '#6b3fd4',
            fontSize: '0.6rem',
            fontWeight: 700,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            lineHeight: 1.6,
            border: isDark ? '1px solid rgba(123,79,224,0.5)' : '1px solid #d9c7ff'
        },
        roleBadgeWrapper: {
            ...globals.textCenter
        },
        dividerTop: {
            ...globals.width100,
            ...globals.getMargin('12px', 't')
        },
        width100: {
            ...globals.width100
        }
    };
});
